import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { LogIn, Gamepad2 } from "lucide-react";

export default function LoginModal({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid="auth-modal"
        className="bg-[hsl(var(--bg-1))] border-[hsl(var(--border-soft))] text-white max-w-md"
      >
        <DialogHeader>
          <DialogTitle className="font-display text-3xl tracking-wide flex items-center gap-2">
            <LogIn className="w-6 h-6" /> Accedi con Minecraft
          </DialogTitle>
          <DialogDescription className="text-[hsl(var(--text-soft))]">
            L'accesso tramite password è stato disattivato. Entra nel server Minecraft e usa il comando qui sotto.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 mt-2">
          <div className="rounded-xl border border-[hsl(var(--brand-500)/0.35)] bg-[hsl(var(--brand-500)/0.10)] p-4">
            <div className="flex items-center gap-3">
              <Gamepad2 className="w-5 h-5 text-[hsl(var(--brand-300))]" />
              <div>
                <div className="text-sm text-[hsl(var(--text-soft))]">Comando in game</div>
                <code className="text-xl text-white font-bold">/gestionale</code>
              </div>
            </div>
          </div>

          <p className="text-sm text-[hsl(var(--text-soft))] leading-relaxed">
            Il server ti invierà un link cliccabile in chat. Cliccandolo verrai loggato automaticamente con il tuo nickname Minecraft.
            Il link dura pochi minuti e può essere usato una sola volta.
          </p>

          <button
            type="button"
            onClick={() => onOpenChange(false)}
            className="btn-brand w-full justify-center inline-flex items-center gap-2"
          >
            Ho capito
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
